import { CreateEditAnnualReview } from '../../../components';

const CreateEditAnnualReviewCycle = () => {
  return (
    <div className="p-[10px]">
      <div className="text-[20px] font-[500]">Create Annual Review Cycle</div>
      <CreateEditAnnualReview />
    </div>
  );
};

export default CreateEditAnnualReviewCycle;
